const enum DiscountType {
  REDEEM = 'REDEEM', // 點數 mode

  REDEEM_PRICE = 'REDEEM_PRICE', // 點數折價
  REDEEM_ITEM = 'REDEEM_ITEM', // 點數換品項
  PRICE_POINT = 'PRICE_POINT', // 滿額集點

  COUPON = 'COUPON', // Coupon mode

  DISCOUNT = 'DISCOUNT', // Coupon 折價
  DISCOUNT_PERCENT = 'DISCOUNT_PERCENT', // 折扣％
  TARGET_PRICE_DISCOUNT = 'TARGET_PRICE_DISCOUNT', // 滿額折價
  TARGET_ITEM = 'TARGET_ITEM', // 滿額送品項
  TARGET_PRICE_DISCOUNT_PERCENT = 'TARGET_PRICE_DISCOUNT_PERCENT', // 滿額折扣%

  DEFAULT = 'DEFAULT',

  BUY_M_GET_N_FREE = 'BUY_M_GET_N_FREE', // 買Ｍ送Ｎ
  BUY_M_GET_PRICE = 'BUY_M_GET_PRICE', // 買Ｍ優惠
  BUY_M_DISCOUNT = 'BUY_M_DISCOUNT', // 買Ｍ折價
  BUY_M_DISCOUNT_PERCENT = 'BUY_M_DISCOUNT_PERCENT', // 買Ｍ折扣%
  BUY_M_POINT = 'BUY_M_POINT', // 買Ｍ送點數

  ADDITIONAL_ITEM = 'ADDITIONAL_ITEM',
  SHARE_MEAL_FEE = 'SHARE_MEAL_FEE',
  SHARE_MEAL = 'SHARE_MEAL',
  COMBO = 'COMBO',
  SERVICE_FEE = 'SERVICE_FEE',
  MIN_CONSUMPTION = 'MIN_CONSUMPTION',
  MAX_QUANTITY = 'MAX_QUANTITY',
  MAX_ORDER_CAPACITY = 'MAX_ORDER_CAPACITY',
}

export default DiscountType;
